import { FC } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

interface OpenGraphProps {
  domain: string;
  sendsparkBrandingEnabled?: boolean;
  workspaceName?: string;
}

const OpenGraph: FC<OpenGraphProps> = ({
  domain,
  sendsparkBrandingEnabled = true,
  workspaceName = '',
}) => {
  const router = useRouter();

  const baseUrl = domain || process.env.NEXT_PUBLIC_REQUEST_DOMAIN || '';
  const apiv2Url = process.env.NEXT_PUBLIC_API_V2_URL || '';
  const facebookAppId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '';

  let ogImageUrl = '';
  let twitterImageUrl = '';
  if (sendsparkBrandingEnabled) {
    /* Linkedin */
    ogImageUrl = `${baseUrl}/assets/request-meta/white-label-off-default.png`;
    twitterImageUrl = `${baseUrl}/assets/request-meta/white-label-off-default.png`;
    /* Twitter */
  } else {
    ogImageUrl = '';
    twitterImageUrl = `${baseUrl}/assets/request-meta/white-label-on-default.png`;
  }

  const url = `${baseUrl}${router.asPath || ''}`;

  const title = 'Record a Video Response';
  let description = `${workspaceName} is requesting a video from you. Click here to start recording!`.trim();
  let siteName = workspaceName;

  if (sendsparkBrandingEnabled) {
    siteName = 'Sendspark Video Request';
    description = `${workspaceName} is requesting a video from you. Click here to start recording with Sendspark!`.trim();
  }

  return (
    <>
      <Head>
        <link
          rel="alternate"
          type="application/json+oembed"
          href={`${apiv2Url}/api/v1/campaigns/oembed?url=${url}&queryParam=requestId`}
        />
        <meta property="fb:app_id" content={facebookAppId} />

        {/* Linkedin */}
        <meta property="og:image" content={ogImageUrl} />
        <meta property="og:image:secure_url" content={ogImageUrl} />

        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:alt" content="Thumbnail for the video" />
        <meta property="og:image:width" content="500" />
        <meta property="og:image:height" content="262.5" />

        {/* Defaults */}
        <meta property="og:site_name" content={siteName} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="article" />

        {/* Twitter */}
        <meta name="twitter:image" content={twitterImageUrl} />
        <meta name="twitter:image:alt" content={title} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@sendspark" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:domain" content={baseUrl} />
        <meta name="twitter:site" content="@sendspark" />
        <meta name="twitter:title" content={title} />
      </Head>
    </>
  );
};

export default OpenGraph;
